import { useState } from "react"
import { Table, Button, Spinner } from "react-bootstrap";
import API from "../../services/axiosInstance";
import Pagination from "../common_modules/pagination";
import { Link, useNavigate } from "react-router-dom";
import Permission from "../security/permission";
import { AUTH_CODE } from "../security/authCodes";
import FilterBar from "../common_modules/filter";
import { LuPenLine, LuArrowRightToLine } from "react-icons/lu";

const DemandPartnerSettingList = () => {
    const [list, setList] = useState([]);
    const [paginationData, setPaginationData] = useState({});
    const [searchConfig, setSearchConfig] = useState();

    // global data
    const tableFields = [
        { label: "Id", value: "id", enableSorting: false, enableTableHeader: false },
        { label: "Publisher", value: "pubName", enableSorting: true, enableTableHeader: true },
        { label: "Domain", value: "domain", enableSorting: true, enableTableHeader: true },
        { label: "Date", value: "createdOn", enableSorting: false, enableTableHeader: true },
        { label: "Status", value: "status", enableSorting: false, enableTableHeader: true }
    ];

    // hooks
    const navigate = useNavigate();

    const editPage = (id) => {       //id=gamId
        navigate(`/gamsetting/${id}/edit`)
    }

    const viewMappingPage = (gamId, pubId, showGamMapping) => {
        navigate(`/gamsetting/${gamId}/${pubId}/${showGamMapping}/gam/mapping`)
    }

    const gamSettingList = async (search, page, field = "", order = "") => {
        try {
            const size = 20;
            const res = await API.get(`/publisher/gam/setting/list?search=${search}&page=${page}&size=${size}&field=${field}&order=${order}`);
            const data = res?.data?.data?.content;
            if (res.status === 200 && data) {
                setList(data);
                // save pagination information
                let pagination = res.data.data;
                delete pagination.content; //  remove data
                setPaginationData(pagination);
            } else {
                setList([]);
                setPaginationData({});
            }
        } catch (error) { } finally {

        }
    }

    const nextPage = (nextPage) => {
        gamSettingList("", nextPage)
    }

    const onChangeSearch = (params) => {
        setSearchConfig(params)
        gamSettingList(params.keyword, 0, params.orderField, params.orderDir); // API call
    }

    // Coverred date in to readble format
    const formatDateTime = (dateString) => {
        if (!dateString) return "-";
        const date = new Date(dateString);
        const day = String(date.getUTCDate()).padStart(2, "0");
        const month = String(date.getUTCMonth() + 1).padStart(2, "0");
        const year = date.getUTCFullYear();

        const hours = String(date.getUTCHours()).padStart(2, "0");
        const minutes = String(date.getUTCMinutes()).padStart(2, "0");
        const seconds = String(date.getUTCSeconds()).padStart(2, "0");

        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    };

    return (
        <div>
            <div className="breadCrumb gradient-bg">
                <Link to={'/dashboard'}><span>Home</span></Link>
                <span>Tech Admin</span>
                <span>Demand Partner 1 Setting</span>
            </div>
            <h4 className="my-4">🧾 Demand Partner 1 Setting</h4>
            <Permission code={AUTH_CODE.demandPartner.gamSettingListing}>

                {/* <div className="active-table-wrapper">
                <div style={{
                    paddingBottom: "0.8rem",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }}>  */}
                <FilterBar fields={tableFields} onSearch={onChangeSearch} />
                {/* </div> */}
                <div className="mt-0 table-wrapper mt-3">
                    <Table striped bordered responsive hover size="sm" className="custom-table align-middle">
                        <thead>
                            <tr>
                                <th>☰</th>
                                {
                                    tableFields?.map((item, i) => {
                                        if (!item.enableTableHeader) {
                                            return false;
                                        }
                                        return (
                                            <th key={i}>{item.label}</th>
                                        )
                                    })
                                }
                                <th className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                list?.length > 0 &&
                                list?.map((item, index) => {
                                    return (
                                        <tr key={index} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 * index }} className="hover-glow">
                                            <td>{(paginationData.number * paginationData.size) + (index + 1)}</td>
                                            {/* <td>{item?.id}</td> */}
                                            <td>{item?.pubName}</td>
                                            <td>{item?.domain}</td>
                                            <td>{formatDateTime(item?.createdOn)}</td>
                                            <td style={{ textAlign: "center" }}>
                                                <span className={`badge ${item?.status === 1 ? "active" : "inactive"}`}>
                                                    {item?.status === 1 ? "Active" : "Inactive"}
                                                </span>
                                            </td>
                                            <td className="activePubAllBtns">
                                                <Permission code={AUTH_CODE.demandPartner.editUpdateGamSetting}>
                                                    <button onClick={() => editPage(item?.id)} size="sm">Edit <LuPenLine /></button>
                                                </Permission>
                                                <Permission code={AUTH_CODE.demandPartner.gamViewMappingList}>
                                                    <button onClick={() => viewMappingPage(item?.id, item?.accountId, 2)} className="icon_show_sm" size="sm" >
                                                        <i class="fa fa-star text-primary"></i>View Mapping <LuArrowRightToLine />
                                                    </button>
                                                </Permission>
                                            </td>
                                        </tr>
                                    );
                                })
                            }
                        </tbody>
                    </Table>
                    {
                        list.length <= 0 && <center>No Data Found !!!</center>
                    }
                    {/* pagination */}
                </div>
                <Pagination jumpPage={true} component={DemandPartnerSettingList.name} size={"sm"} paginationData={paginationData} nextPage={nextPage} />
                {/* </div> */}
                {/* </div> */}
            </Permission>
        </div>
    );
};

export default DemandPartnerSettingList;